import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";
import { compareRows } from "@/mocks/siteData";

export default function CompareSection() {
  return (
    <section id="compare" className="bg-background-50 py-20 md:py-28">
      <div className="mx-auto w-full max-w-5xl px-4 md:px-6">
        <Reveal>
          <SectionHeading kicker="Compare" title="개인회생 vs 개인파산" />
        </Reveal>

        <Reveal delay={100}>
          <div className="mt-12 hidden overflow-hidden rounded-lg border border-background-200/70 md:block">
            <div className="grid grid-cols-[1.1fr_1.4fr_1.4fr] bg-background-100/80">
              <div className="px-5 py-4 text-sm font-medium text-foreground-500">구분</div>
              <div className="border-l border-background-200/60 px-5 py-4 text-sm font-medium text-primary-400">
                개인회생
              </div>
              <div className="border-l border-background-200/60 px-5 py-4 text-sm font-medium text-accent-400">
                개인파산
              </div>
            </div>
            {compareRows.map((row, i) => (
              <div
                key={row.label}
                className={`grid grid-cols-[1.1fr_1.4fr_1.4fr] ${
                  i % 2 === 1 ? "bg-background-100/30" : "bg-background-50"
                }`}
              >
                <div className="px-5 py-4 text-sm text-foreground-700">{row.label}</div>
                <div className="border-l border-background-200/60 px-5 py-4 text-sm text-foreground-800">
                  {row.rehab}
                </div>
                <div className="border-l border-background-200/60 px-5 py-4 text-sm text-foreground-800">
                  {row.bankrupt}
                </div>
              </div>
            ))}
          </div>

          <div className="mt-12 space-y-3 md:hidden">
            {compareRows.map((row) => (
              <div
                key={row.label}
                className="overflow-hidden rounded-lg border border-background-200/70 bg-background-50"
              >
                <div className="bg-background-100/80 px-4 py-3 text-sm font-medium text-foreground-700">
                  {row.label}
                </div>
                <div className="flex items-start gap-3 px-4 py-3">
                  <span className="mt-0.5 shrink-0 rounded-full bg-primary-950/70 px-2.5 py-1 text-xs text-primary-400">
                    회생
                  </span>
                  <span className="text-sm text-foreground-800">{row.rehab}</span>
                </div>
                <div className="flex items-start gap-3 border-t border-background-200/60 px-4 py-3">
                  <span className="mt-0.5 shrink-0 rounded-full bg-accent-950/70 px-2.5 py-1 text-xs text-accent-300">
                    파산
                  </span>
                  <span className="text-sm text-foreground-800">{row.bankrupt}</span>
                </div>
              </div>
            ))}
          </div>

          <p className="mt-6 text-center text-xs leading-relaxed text-foreground-500 md:text-sm">
            ※ 위 내용은 일반적 안내이며, 개별 사안에 따라 달라질 수 있습니다. 정확한 진단은
            상담을 통해 확인하세요.
          </p>
        </Reveal>
      </div>
    </section>
  );
}